// ============= Shared Types for Ask =============

export interface InvokeAskVariable {
  key: string;
  value: string;
}

export enum AskType {
  MESSAGE = 'Message',
  USER_REQUEST = 'UserRequest',
  USER_RESPONSE = 'UserResponse',
  USER_INTERNAL_MESSAGE  = 'UserInternalMessage',
}

export interface InvokeAskRequest {
  input: string;
  inputTypeIndex: number;
  variables: InvokeAskVariable[];
  selectedDocuments: string[];
  documentCollections: string[];
  workspaceId: string;
  askPromptId: string;
  askType: AskType;
}

export interface InvokeAskResponse {
  message?: any;
  [key: string]: any;
}

export interface SendAskMessageToUsersRequest {
  message: string;
  [key: string]: any;
}

export interface SendAskMessageToUsersResponse {
  success?: boolean;
  [key: string]: any;
}
